import {
    queryStringParse,
} from 'dna-core/components/utils/js/queryString';

export default {
	get app() {
		return {
			get name() {
				return window.GG.jgLoginAppSettings.APP_NAME;
			},
			get version() {
				return window.GG.jgLoginAppSettings.APP_VERSION;
			},
		};
	},
	get iam() {
		return {
			get baseUrl() {
				let iamQueryStringUrl = queryStringParse(location.search).iamUrl;
				let iamUrl = iamQueryStringUrl || window.GG.jgLoginAppSettings.IAM_API.BASE_URL;
				return iamUrl.endsWith('/') ? iamUrl : `${iamUrl}/`;
			},
			get facebookLoginUrl() {
				return `${this.baseUrl}${window.GG.jgLoginAppSettings.IAM_API.ENDPOINTS.FB_LOGIN_URL}`;
			},
			get jgLoginUrl() {
				return `${this.baseUrl}${window.GG.jgLoginAppSettings.IAM_API.ENDPOINTS.JG_LOGIN_URL}`;
			},
			get registerAndLoginUrl() {
				return `${this.baseUrl}${window.GG.jgLoginAppSettings.IAM_API.ENDPOINTS.REGISTER_AND_LOGIN_URL}`;
			},
			get emailCheckUrl() {
				return `${this.baseUrl}${window.GG.jgLoginAppSettings.IAM_API.ENDPOINTS.EMAIL_CHECK_URL}`;
			},
		};
	},
	get imageService() {
		return {
			get baseUrl() {
				return window.GG.jgLoginAppSettings.IMAGE_SERVICE_URL;
			},
			get defaultSize() {
				return window.GG.jgLoginAppSettings.IMAGE_SERVICE_SIZE;
			},
		};
	},
	get defaultLocale() {
		return window.GG.jgLoginAppSettings.DEFAULT_LOCALE;
	},
	get JgAnalyticsCookieName() {
		return window.GG.jgLoginAppSettings.JG_ANALYTICS_COOKIE_NAME;
	},
	get requestTimeoutDeadline() {
		return window.GG.jgLoginAppSettings.REQUEST_TIMEOUT_DEADLINE;
	},
	get clientId() {
		return window.GG.jgLoginAppSettings.CLIENT_ID;
	},
	get resetPasswordLink() {
		return 'http://www.justgiving.com/signin/?m=pwreset';
	}
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/config/config.js